<template>
  <div ref="selector" :class="`selector${top ? ' selector--top' : ''}${isOpen ? ' is-open' : ''}`">
    <input
      v-on:focus="onFocus"
      v-model="value"
      :placeholder="placeholder"
      class="selector-input"
      type="text"
    />

    <div class="selector-dropdown">
      <div class="selector-dropdown-header">
        <input
          v-model="valueToAdd"
          v-on:keypress="keyPress"
          ref="dropdownInput"
          class="selector-dropdown-input"
          type="number"
          placeholder="Term(s) to search"
        />
        <i v-on:click="addValue" class="fas fa-plus"></i>
      </div>

      <ul v-if="list && list.length > 0" class="selector-dropdown-list">
        <li v-for="(term, i) in list" :key="`selector-${term}-${i}`">
          {{ term }}
          <i v-on:click.stop="removeValue(term)" class="fas fa-times"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["originalValue", "placeholder", "top"],
  watch: {
    originalValue: {
      handler: function(val) {
        this.value = val;
      }
    }
  },
  computed: {
    list() {
      // console.log('this.value :', this.value);
      return this.value.length === 0 ? [] : this.value.split(", ");
    }
  },
  data() {
    return {
      value: this.originalValue || "",
      valueToAdd: "",
      isOpen: false
    };
  },
  methods: {
    onFocus() {
      this.open();
      this.$refs.dropdownInput.focus();
    },
    onClickBody(e) {
      const $target = e.target;
      const isChild =
        this.$refs.selector && this.$refs.selector.contains($target);

      if (!isChild) {
        this.close();
      }
    },
    keyPress(e) {
      if (e.keyCode === 13) {
        if (this.valueToAdd.length === 0) {
          this.close();
        } else {
          this.addValue();
        }
      }
    },
    open() {
      this.isOpen = true;

      if (!this._onClickBody) {
        this._onClickBody = this.onClickBody.bind(this);
      }

      document.body.addEventListener("click", this._onClickBody);
    },
    close() {
      this.isOpen = false;

      if (this._onClickBody) {
        document.body.removeEventListener("click", this._onClickBody);
      }

      this.$emit("onValueChanged", this.value);
    },
    addValue() {
      this.value = `${this.value}, ${this.valueToAdd}`;
      this.valueToAdd = "";

      this.cleanValue();
      this.$refs.dropdownInput.focus();
      this.$emit("onValueChanged", this.value);
    },
    removeValue(value) {
      // Replace the value
      this.value = this.value.replace(value, "").replace();
      this.cleanValue();
      this.$emit("onValueChanged", this.value);
    },
    cleanValue() {
      // Remove extra comma
      this.value = this.value
        .trim()
        .replace(/,$|^,/g, "")
        .replace(/, ,/g, ",")
        .trim();
    }
  }
};
</script>

<style lang="scss">
.selector {
  position: relative;
  width: 100%;

  &--top {
    .selector-dropdown {
      flex-direction: column-reverse;
      top: auto;
      bottom: -10px;
    }
  }

  &.is-open {
    .selector-input {
      opacity: 0;
      pointer-events: none;
    }

    .selector-dropdown {
      opacity: 1;
      pointer-events: all;
      z-index: 99;
    }
  }

  &-input {
    position: relative;
    background-color: #fff;
    z-index: 2;
  }

  &-dropdown {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: -10px;
    left: 0;
    z-index: 1;
    width: 100%;
    padding-top: 10px;
    border-radius: 0 0 3px 3px;
    background: #fff;
    opacity: 0;
    pointer-events: none;

    &::after {
      content: "";
      position: absolute;
      left: -15px;
      top: 0;
      z-index: -1;
      width: calc(100% + 30px);
      height: 100%;
      border-radius: 3px;
      background: #fff;
      box-shadow: 0 0 15px 1px rgba(69, 65, 78, 0.2);
    }

    &-header {
      position: relative;
      margin-bottom: 10px;

      i {
        position: absolute;
        right: 0;
        top: 8px;
      }
    }

    &-input {
      width: 100%;
    }

    &-list {
      width: calc(100% + 15px);
      margin-top: -10px;
      padding: 10px 15px 10px 0;
      max-height: 250px;
      overflow: auto;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: auto;
        padding: 0;
        color: #292c33;
        line-height: 1;
        cursor: auto;

        i {
          padding: 10px !important;
          margin-right: -10px;
          cursor: pointer;
        }

        + li {
          border-top: 1px solid lighten(#ced4da, 10%);
        }
      }
    }
  }
}
</style>
